export default "__VITE_ASSET__BBM9Q5WM__"